import { useForm } from "react-hook-form";
import {
    IAudiencia,
    IComunicadoEmMassa,
} from "../../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import Table from "../../../../Components/Table";
import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";
import React, { ChangeEvent, useEffect, useState } from "react";
import { ComunicadoEmMassaController } from "../../../../Controllers/Automacao/Audiencia/AudienciaControllers";
import { FroalaEditor } from "../../../../Components/CardsPages/Forms/Editor/FroalaEditor";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import { ListarTipoDocumentoController } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoDocumento/TipoDocumentoController";
import { TipoDocumentoInterface } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoDocumento/TipoDocumentoInterface";
import { ListarMensagensTemplate } from "../../../../Services/HelpDesk/GestaoAtendimentos/GestaoAtendimentosService";
import { ValidationErr } from "../../../../Validations/ValidationError";
import { ListarDocumentoTemplateTipoDocumentoController } from "../../../../Controllers/Geral/Documentos/DocumentosController";
import { IMensagemTemplate } from "../../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { IDocumentosTemplate } from "../../../../Interfaces/Geral/Documentos/DocumentosInterface";
interface htmlQuill {
    editorHtml: string;
}
interface IComunicadoEmMassaProps {
    updateList: () => void;
    setModal: (show: boolean) => void;
    lstAudiencia: IAudiencia[] | undefined;
}

export default function ComunicadoEmMassa(props: IComunicadoEmMassaProps) {
    const { register, handleSubmit, getValues, reset, watch, setValue } =
        useForm();
    const [lstAudienciaSelected, setLstAudienciaSelected] = useState<
        IAudiencia[]
    >([]);
    const [convertedText, setConvertedText] = useState<htmlQuill>({
        editorHtml: "",
    } as htmlQuill);
    const [uploading, setUploading] = useState(false);
    const [tipoComunicacao, setTipoComunicacao] = useState("");
    const [lstTipoDocumento, setLstTipoDocumento] =
        useState<Array<TipoDocumentoInterface>>();
    const [lstMessage, setLstMessage] = useState<IMensagemTemplate[]>([]);
    const [lstTemplates, setLstTemplates] = useState<
        Array<IDocumentosTemplate>
    >([]);

    const [valueMessagemSelecionada, setValueMessagemSelecionada] =
        useState("");

    function handleGetTemplateList(e: ChangeEvent<HTMLSelectElement>) {
        ListarDocumentoTemplateTipoDocumentoController(
            Number(e.target.value)
        ).then((res) => {
            setLstTemplates(res);
        });
    }

    function handleSetTemplate(e: ChangeEvent<HTMLSelectElement>) {
        const findTemplate = lstTemplates.find(
            (template) =>
                template.ID_DOCUMENTO_TEMPLATE === Number(e.target.value)
        );
        setValue("DS_ASSUNTO", findTemplate?.DS_ASSUNTO);
        setConvertedText({ editorHtml: findTemplate?.DS_TEMPLATE ?? "" });
    }

    async function lstMensagemTemplate() {
        await ListarMensagensTemplate()
            .then((response) => {
                if (response.status === 200) {
                    setLstMessage(response.data);
                }
            })
            .catch((err) => {
                ValidationErr(err);
                throw err;
            });
    }
    useEffect(() => {
        ListarTipoDocumentoController().then((res) => {
            const filterRes = res.filter(
                (tipoDoc) =>
                    tipoDoc.DS_CLASSIFICACAO_DOCUMENTO ===
                    "Agendamento Vistoria"
            );
            setLstTipoDocumento(filterRes);
        });
        lstMensagemTemplate();
    }, []);

    const onSubmit = (formData: any) => {
        const lstAudienciaIdsSelected = lstAudienciaSelected.map(
            (audiencia) => audiencia.ID_AUDIENCIA
        );
        let formattedData: IComunicadoEmMassa = {
            DS_MENSAGEM: "",
            DS_ASSUNTO: "",
            idAudiencias: [],
        };
        if (getValues("DS_TIPO_COMUNICACAO") !== "WhatsApp") {
            formattedData = {
                DS_ASSUNTO: formData.DS_ASSUNTO,
                idAudiencias: lstAudienciaIdsSelected,
                DS_MENSAGEM: convertedText.editorHtml,
                ID_DOCUMENTO_TEMPLATE: formData.ID_DOCUMENTO_TEMPLATE,
            };
        } else {
            formattedData = {
                DS_ASSUNTO: "",
                idAudiencias: lstAudienciaIdsSelected,
                DS_MENSAGEM: formData.DS_WHATSAPP,
            };
        }
        ComunicadoEmMassaController(
            formData.DS_TIPO_COMUNICACAO,
            formattedData
        ).then(() => {
            props.setModal(false);
        });
        setConvertedText({ editorHtml: "" });
        reset();
    };

    function handleChange(html: string) {
        setConvertedText({ editorHtml: html });
    }

    const ColunsAudiencia: Array<ColumnDescription> = [
        {
            dataField: "DS_AUDIENCIA",
            text: "Audiencia",
            formatter: (cell: any, row: IAudiencia) => (
                <div className="">
                    <div>
                        <h4>{row.DS_AUDIENCIA}</h4>
                    </div>
                </div>
            ),
            sort: true,
            isDummyField: true,
        },
    ];

    const selectRow: SelectRowProps<any> = {
        mode: "checkbox",
        onSelect: (row, isSelected) => {
            if (isSelected)
                setLstAudienciaSelected((audiencia) => [...audiencia, row]);
            else
                setLstAudienciaSelected((audiencias) =>
                    audiencias.filter(
                        (audiencia) =>
                            audiencia.ID_AUDIENCIA !== row.ID_AUDIENCIA
                    )
                );
        },
        onSelectAll: (isSelected, rows) => {
            if (isSelected) setLstAudienciaSelected(rows);
            else setLstAudienciaSelected([]);
        },
    };

    return (
        <>
            <div className="text-center mb-10">
                <h2 className="font-weight-bold">Enviar Comunicado em Massa</h2>
            </div>
            <form
                className="form"
                id="kt_login_signin_form"
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className="form-group b-5 col-12">
                    <label>Tipo Comunicação</label>
                    <select
                        className="form-control"
                        name="DS_TIPO_COMUNICACAO"
                        ref={register()}
                        onChange={(e) => setTipoComunicacao(e.target.value)}
                    >
                        <option></option>
                        <option>Email</option>
                        <option>WhatsApp</option>
                        {/* <option>SMS</option> */}
                    </select>
                </div>
                {tipoComunicacao !== "WhatsApp" ? (
                    <>
                        <div className="form-group b-5 col-12">
                            <label>Tipo Documento</label>
                            <select
                                className="form-control"
                                name="ID_TIPO_DOCUMENTO"
                                ref={register()}
                                onChange={(e) => handleGetTemplateList(e)}
                            >
                                <option></option>
                                {lstTipoDocumento &&
                                    lstTipoDocumento.map((documento) => (
                                        <option
                                            key={documento.ID_TIPO_DOCUMENTO}
                                            value={documento.ID_TIPO_DOCUMENTO}
                                        >
                                            {documento.DS_TIPO_DOCUMENTO}
                                        </option>
                                    ))}
                            </select>
                        </div>
                        <div className="form-group b-5 col-12">
                            {watch("ID_TIPO_DOCUMENTO", true) && (
                                <>
                                    <label>Templates</label>
                                    <select
                                        className="form-control"
                                        name="ID_DOCUMENTO_TEMPLATE"
                                        ref={register()}
                                        onChange={(e) => handleSetTemplate(e)}
                                    >
                                        <option></option>
                                        {lstTemplates &&
                                            lstTemplates.map((templates) => (
                                                <option
                                                    key={
                                                        templates.ID_DOCUMENTO_TEMPLATE
                                                    }
                                                    value={
                                                        templates.ID_DOCUMENTO_TEMPLATE
                                                    }
                                                >
                                                    {templates.DS_DOCUMENTO}
                                                </option>
                                            ))}
                                    </select>
                                </>
                            )}
                        </div>
                        <div className="form-group b-5 col-12">
                            <label>Assunto</label>
                            <input
                                className={`form-control h-auto placeholder-dark-75`}
                                type="text"
                                name="DS_ASSUNTO"
                                ref={register()}
                            />
                        </div>
                        <div className="form-group b-5 col-12">
                            <label>Descrição</label>
                            {uploading && (
                                <div className="d-flex align-items-center justify-content-center g-2 p-2">
                                    Fazendo upload de imagem{" "}
                                    <Spinner size="sm" color="primary" />
                                </div>
                            )}

                            <FroalaEditor
                                value={convertedText.editorHtml || ""}
                                onChange={handleChange}
                                onImageUploadStart={() => setUploading(true)}
                                onImageUploadEnd={() => setUploading(false)}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <div className="form-group b-5 col-12">
                            <select
                                className="form-control"
                                name="DS_WHATSAPP"
                                ref={register({
                                    required: "Selecione uma mensagem",
                                    valueAsNumber: false,
                                    min: {
                                        value: 1,
                                        message: "Favor selecione uma mensagem",
                                    },
                                })}
                                onChange={(e) => {
                                    setValueMessagemSelecionada(e.target.value);
                                }}
                            >
                                <option key={0} value={""}>
                                    {" "}
                                    Selecione uma mensagem
                                </option>
                                {lstMessage?.length &&
                                    lstMessage.map((mensagem, index) => {
                                        const dsCorpoTemplate =
                                            mensagem.DS_CORPO_TEMPLATE.length >
                                            100
                                                ? mensagem.DS_CORPO_TEMPLATE.substring(
                                                      0,
                                                      100
                                                  ) + "..."
                                                : mensagem.DS_CORPO_TEMPLATE;

                                        return (
                                            <option
                                                key={index + 1}
                                                value={
                                                    mensagem.DS_CORPO_TEMPLATE
                                                }
                                            >
                                                {dsCorpoTemplate}
                                            </option>
                                        );
                                    })}
                            </select>
                        </div>
                        {valueMessagemSelecionada &&
                            valueMessagemSelecionada.length > 0 && (
                                <div className="form-group b-5 col-12">
                                    <label>Mensagem selecionada</label>
                                    <textarea
                                        className="form-control"
                                        style={{ height: "150px" }}
                                        disabled
                                        value={valueMessagemSelecionada}
                                    />
                                </div>
                            )}
                    </>
                )}
                <div className="form-group b-5 col-12">
                    <Table
                        keyField={"ID_AUDIENCIA"}
                        columns={ColunsAudiencia}
                        data={props.lstAudiencia || []}
                        rowClasses="checkbox-table"
                        classes="tableClass"
                        selectRow={selectRow}
                        bodyClasses="bodyClass"
                        bordered
                        noSearch
                    />
                </div>
                <div className="d-flex flex-wrap justify-content-center align-items-center">
                    <button
                        type="submit"
                        id="kt_login_signin_submit"
                        className="btn btn-capys font-weight-bold px-9 py-4 my-2"
                    >
                        Enviar
                    </button>
                </div>
            </form>
        </>
    );
}
